import { Divider, Heading, SpaceProps, VStack } from "@chakra-ui/react"
import { ReactNode, forwardRef } from "react"
import { COVER_PAGE_PADDING } from "./constants"

type CoverPageDividerProps = {
  title?: string
  renderTitle?: () => ReactNode
  verticalMargin?: SpaceProps["paddingTop"] | SpaceProps["paddingBottom"]
  horizontalMargin?: SpaceProps["paddingLeft"] | SpaceProps["paddingRight"]
  titleMargin?: SpaceProps["marginTop"] | SpaceProps["marginBottom"]
}

const CoverPageDivider = forwardRef<HTMLDivElement, CoverPageDividerProps>(
  (
    {
      title,
      renderTitle,
      verticalMargin = "30px",
      horizontalMargin = COVER_PAGE_PADDING,
      titleMargin
    },
    ref
  ) => {
    return (
      <VStack
        ref={ref}
        className="CoverPageDivider"
        align="start"
        w="100%"
        gap={0}
        px={horizontalMargin}
        scrollMarginTop="20px"
      >
        <Divider
          my={verticalMargin}
          h="1px"
          border="none"
          bg="blackAlpha.200"
          w="100%"
        />
        {title || renderTitle ? (
          <Heading
            as="h3"
            size="h7"
            m={0}
            color="PRIMARY_GRAY"
            mb={titleMargin || verticalMargin}
            className="theme-heading theme-heading-semibold"
          >
            {renderTitle ? renderTitle() : title}
          </Heading>
        ) : null}
      </VStack>
    )
  }
)

export default CoverPageDivider
